import { render, staticRenderFns } from "./page-meditation-categories.vue?vue&type=template&id=15baff14&"
import script from "./page-meditation-categories.vue?vue&type=script&lang=ts&"
export * from "./page-meditation-categories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports